import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Stack, NavLink } from "@mantine/core";
import { TEXT_COLOR } from "../theme/colors";
const StepButton = ({ active, finished, icon, label, onClick, disabled, }) => {
    return (_jsx(NavLink, { sx: {
            "&[data-disabled]": {
                opacity: 1,
            },
        }, color: finished ? undefined : TEXT_COLOR.PLACEHOLDER, icon: active ? icon.active : finished ? icon.finished : icon.unfinished, label: label, active: active, onClick: onClick, disabled: disabled }));
};
const StepperStep = ({ active, finished, label, hidden, onClick, disabled, icon, }) => {
    if (hidden) {
        return null;
    }
    return (_jsx(StepButton, { onClick: onClick, active: active, finished: finished, icon: icon, label: label, disabled: disabled }));
};
const VerticalSidebarStepProgress = ({ steps, ...rest }) => {
    return (_jsx(Stack, { spacing: 0, ...rest, children: steps.map((s, i) => (_jsx(StepperStep, { ...s }, i))) }));
};
export default memo(VerticalSidebarStepProgress);
